import Api from "../api";
let uri = '/api/ed/escolaridad';

export const getEscolaridades = () => {
    return Api.getInstance().executeGetQuery(`${uri}`)
    .then((resp) => resp.data)
    .catch((error) =>
        console.log(error)
    );
}